export default {
  "content": "<path d=\"M14 6.667c0 4.666-6 8.666-6 8.666s-6-4-6-8.666a6 6 0 1112 0z\" stroke=\"#A7AEC5\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M8 8.667a2 2 0 100-4 2 2 0 000 4z\" stroke=\"#A7AEC5\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};